import { render, staticRenderFns } from "./CardNumPrj.vue?vue&type=template&id=794a24e6&scoped=true&"
import script from "./CardNumPrj.vue?vue&type=script&lang=js&"
export * from "./CardNumPrj.vue?vue&type=script&lang=js&"
import style0 from "./CardNumPrj.vue?vue&type=style&index=0&id=794a24e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a24e6",
  null
  
)

export default component.exports